import { GetState, SetState, State } from 'zustand';

type FunctionSetterArg<S> = (prevState: S) => S;
type SetterArg<S> = S | FunctionSetterArg<S>;
export type Setter<S> = (arg: SetterArg<S>) => void;

function isFunctionSetterArg(arg: any): arg is FunctionSetterArg<any> {
	return typeof arg === 'function';
}

// this is necessary to mimic the behavior of useState where the setter can take a function or a value
function createSetter<T extends State>(
	set: SetState<T>,
	get: GetState<T>,
	key: keyof T
) {
	return <S>(arg: SetterArg<S>): void => {
		if (isFunctionSetterArg(arg)) {
			const prevState = get()[key];
			const data = arg(prevState);

			set({ [key]: data } as Record<typeof key, any>);
		} else {
			set({ [key]: arg } as Record<typeof key, any>);
		}
	};
}

export default createSetter;